import { ShieldOff } from 'lucide-react'
import { GATE_HOME_URL, gateLogoutUrl } from '../utils/gate'

/**
 * Единый вход подтвердил человека, но допуска к CRM у него нет. Не уводим обратно на вход
 * (получился бы цикл): объясняем причину и даём выйти или вернуться на ecmit.su.
 */
export default function NoAccessPage({ message }: { message: string }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 dark:bg-gray-900">
      <div className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-6 text-center shadow-sm dark:border-gray-700 dark:bg-gray-800">
        <ShieldOff className="mx-auto mb-3 h-10 w-10 text-gray-400" aria-hidden="true" />
        <h1 className="mb-2 text-xl font-semibold text-gray-900 dark:text-white">Нет доступа к CRM</h1>
        <p className="mb-5 text-sm text-gray-600 dark:text-gray-300">{message}</p>
        <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
          <a className="btn btn-primary" href={GATE_HOME_URL}>На ecmit.su</a>
          <a className="btn btn-secondary" href={gateLogoutUrl(`${window.location.origin}/login`)}>Войти под другой учётной записью</a>
        </div>
      </div>
    </div>
  )
}
